module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "result bg-white a4"
  }, [_c('div', {
    staticClass: "result-title hidden-print__no"
  }, [_c('h1', {
    staticClass: "text-uppercase"
  }, [_vm._v(_vm._s(_vm.comitente.nome) + " - RELATÓRIO MÉDIA DE RECUPERAÇÃO X FIPE")]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.period))]), _vm._v(" "), _c('div', {
    staticClass: "text-center hidden-print"
  }, [_c('a', {
    on: {
      "click": _vm.print
    }
  }, [_c('i', {
    staticClass: "fa fa-print"
  }), _vm._v(" imprimir "), _c('span', {
    staticClass: "font-thin"
  }, [_vm._v("(CTRL + P)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "c-result printer-page"
  }, [_c('h3', {
    staticClass: "comitente-nome text-uppercase"
  }, [_vm._v(_vm._s(_vm.comitente.nome))]), _vm._v(" "), _vm._l((_vm.data.mediaMeses), function(leilao, mes) {
    return _c('div', [_c('h4', {
      staticStyle: {
        "background-color": "#f2f2f2 !important",
        "-webkit-print-color-adjust": "exact"
      }
    }, [_vm._v(_vm._s(_vm._f("translateMes")(mes)))]), _vm._v(" "), _c('table', {
      staticClass: "tbl-result"
    }, [_c('tr', [_c('th', {
      staticStyle: {
        "color": "#000"
      }
    }, [_vm._v("Média Fipe")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "color": "#000"
      }
    }, [_vm._v(_vm._s(_vm.an(leilao.salvadosPercentualFipe)) + "%")])]), _vm._v(" "), _c('tr', [_c('th', {
      staticStyle: {
        "color": "#000"
      }
    }, [_vm._v("Média Venda")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "color": "#000"
      }
    }, [_vm._v(_vm._s(_vm.an(leilao.percentualVenda)) + "%")])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "chart m-t"
  }, [_c('highcharts', {
    attrs: {
      "options": _vm.options
    }
  })], 1)], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-81b96d50","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/relatorios-basicos/components/ResultMediaFipeComitenteMes.vue
// module id = 1802
// module chunks = 17